import {
  ACTIONS_COLUMN_MIN_WIDTH,
  ListingColumnPreferenceRow,
  minWidthForListingColumnKey,
} from "../../constants/listingColumnKeys";
import {
  ColumnWithListingKey,
  ApplyListingColumnPreferencesOptions,
} from "./applyListingColumnPreferences";

/**
 * Applies widths from the visible table columns onto the full persisted preference rows
 * (order + visibility unchanged; hidden columns keep their stored widths).
 */
export function mergeListingWidthsFromTable(
  tableColumns: ColumnWithListingKey[],
  persistedRows: ListingColumnPreferenceRow[],
  options?: Pick<
    ApplyListingColumnPreferencesOptions,
    "actionsMinWidth"
  >
): ListingColumnPreferenceRow[] {
  const actionsMin = options?.actionsMinWidth ?? ACTIONS_COLUMN_MIN_WIDTH;
  const widthByKey: Record<string, number> = {};
  for (const col of tableColumns) {
    const key = col.listingColumnKey;
    if (!key) continue;
    const raw = col.width;
    const w = typeof raw === "number" ? raw : Number(raw);
    if (!Number.isFinite(w)) continue;
    const min = minWidthForListingColumnKey(key, actionsMin);
    widthByKey[key] = Math.max(min, Math.round(w));
  }
  if (!persistedRows.length) return persistedRows;
  return persistedRows.map((row) => {
    const w = widthByKey[row.key];
    if (w === undefined) return row;
    return { ...row, width: w };
  });
}
